import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { FilterAutocomplete } from "../Form/FilterAutocomplete";
import { getAllPlayoffs } from "../../apis/Playoff";
import { debounce } from "lodash";
import { axiosInstance } from "../../config/axios";
import { FullHeightLoader } from "../Loader/FullHeightLoader";
import { Group } from "./Group";
import { useGrapeList } from "./context/GrapeListProvider";

export const AddPlayoffProductsDialog = () => {
	const [playoff, setPlayoff] = useState(null);
	const [groups, setGroups] = useState([]);
	const [loading, setLoading] = useState(true);
	const [reset, setReset] = useState(false);
	const { open, handleClose } = useGrapeList();

	const handleChange = useMemo(
		() => debounce((name, item) => {
			if (item) {
				setPlayoff(item);
			}
		}, 500),
		[],
	);
	useEffect(() => {
		if (!playoff) {
			return;
		}
		setGroups(playoff?.groups || []);
	}, [playoff]);

	useEffect(() => {
		if (open) {
			setPlayoff(null);
			setGroups([]);
		}
		setReset(open);
	}, [open]);

	useEffect(() => {
		const missingGroups = groups.filter((g) => !("products" in g));

		if (missingGroups.length === 0) {
			setLoading(false);
			return;
		}

		setLoading(true);

		Promise.all(
			missingGroups.map((g) =>
				axiosInstance
					.get(`group-products/${g.id}/`)
					.then((res) => ({ ...g, products: res.data }))
					.catch((err) => {
						console.error(`Failed to fetch group ${g.id}`, err);
						return g; // fallback: return group unchanged
					}),
			),
		)
			.then((fetchedGroups) => {
				setGroups((prevGroups) =>
					prevGroups.map((pg) => {
						const updated = fetchedGroups.find(
							(fg) => fg.id === pg.id,
						);
						return updated ? updated : pg;
					}),
				);
			})
			.finally(() => setLoading(false));
	}, [groups, setGroups]);

	return (
		<Dialog
			open={open}
			keepMounted
			onClose={handleClose}
			PaperProps={{
				sx: {
					width: 900,
					p: 4,
					// maxWidth: "95vw",
				},
			}}
			maxWidth={"md"}
		>
			<DialogTitle>{"Products from Playoffs"}</DialogTitle>
			<DialogContent>
				<Grid container spacing={4} py={2} alignItems={"center"}>
					<Grid item xs={12}>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							// pt={5}
							width="100%"
						>
							<Typography variant="h6">Groups</Typography>

							<Box width={{ xs: "100%", sm: 300 }}>
								<FilterAutocomplete
									fetchOptions={getAllPlayoffs}
									label="Playoff"
									handleChange={handleChange}
									name="playoff"
									reset={reset}
									setReset={setReset}
								/>
							</Box>
						</Box>
					</Grid>
					{loading && <FullHeightLoader />}
					{/* <Box sx={{ height: 2 }}></Box> */}

					{groups.map((group) => (
						<Group key={group.id} group={group} />
					))}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleClose}>
					Add Selected Products
				</Button>
			</DialogActions>
		</Dialog>
	);
};
